export default {
  name: 'StepsSummaryComponent',
  props: ['currentStep', 'stepsQuantity'],
  data() {
    return {
      indeterminate: false,
      rotate: 270,
      size: 76,
      value: (this.$props.currentStep / this.$props.stepsQuantity) * 100,
      width: 6,
      color: 'rgb(58, 193, 148)',
    };
  },
};
